import ProfileDetailUserDataSubAccountsItemViewDetailed from './ProfileDetailUserDataSubAccountsItemViewDetailed';
import ProfileDetailUserDataSubAccountsItemViewCard from './ProfileDetailUserDataSubAccountsItemViewCard';
import { useUrlParams } from '../../hooks';
import { IUserData } from '@/lib/interface';
import { cn } from '@/lib/utils';

type TProps = {
	accounts: IUserData[];
	forceCompact?: boolean;
}

const ProfileDetailUserDataSubAccountsView = ({ accounts, forceCompact }: TProps) => {

	const { view } = useUrlParams();

	if (forceCompact || view === 'compact') {
		return (
			<div className={cn(
				'grid grid-cols-2 gap-3',
				'sm:grid-cols-3 sm:gap-4', // sm
				'md:grid-cols-4 md:gap-6', // md
				'lg:grid-cols-5', // lg
				'xl:grid-cols-6' // xl
			)}>
				{
					[...accounts]
						.map(
							l => (
								<ProfileDetailUserDataSubAccountsItemViewCard
									key={l._id}
									user={l} />
							)
						)
				}
			</div>
		);
	}

	return (
		<div className={cn(
			'grid grid-cols-1 gap-3'
		)}>
			{
				[...accounts]
					.map(
						l => (
							<ProfileDetailUserDataSubAccountsItemViewDetailed
								key={l._id}
								user={l} />
						)
					)
			}
		</div>
	);

};

export default ProfileDetailUserDataSubAccountsView;
